'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { SectionHeader, styles } from '../../product-landing/ProductLanding';

export default function WhatIsMcpSection() {
  const { t } = useTranslation('start');
  const rawBody = t('mcp.whatIsMcp.body');
  const paragraphs = typeof rawBody === 'string'
    ? rawBody.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean)
    : [];
  return (
    <section className={styles.section}>
      <div className={styles.split}>
        <div>
          <span className={styles.icon} aria-hidden="true"><AccountTreeIcon /></span>
          <SectionHeader title={t('mcp.whatIsMcp.title')} left />
        </div>
        <div className={styles.prose}>
          {paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
        </div>
      </div>
    </section>
  );
}
